module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Air-conditioning-f243184bcdc283055f888ea29ed5d3d6.svg";